import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-timelinedownload',
  templateUrl: './timelineread.page.html',
  styleUrls: ['./timelineread.page.scss'],
})
export class TimelinereadPage implements OnInit {
  @Input() lista;
  @Input() numContrato;
  @Input() lucLoja = '';

  dataHoje;
  constructor(private modalCtrl:ModalController) { }

  ngOnInit() {
    ////console.log(this.lista);
    this.dataHoje=new Date();
  }
  dismiss(){
    this.modalCtrl.dismiss();
  }
}
